import { Component } from '@angular/core';
import { NotificationBaseComponent } from 'app/shared/components/notifications/notification-base.component';

@Component({
    ...NotificationBaseComponent.metaData,
    selector: 'app-notification-alert-box-adult-child',
    templateUrl: './notification-alert-box-adult-child.component.html',
    styleUrls: ['./notification-alert-box-adult-child.component.scss'],
    standalone: false
})
export class NotificationAlertBoxAdultChildComponent extends NotificationBaseComponent {
}
